import ApiService from "@/services/api.service"

export const MarkingService = {
  getSettings() {
    return ApiService.get(`marking/settings`)
  },
  saveSettings(params) {
    return ApiService.post(`marking/settings`, params)
  },
  getAuthKey() {
    return ApiService.get(`marking/auth/key`)
  },
  signIn(uuid, signature) {
    return ApiService.post(`marking/auth/sign-in`, { uuid, signature })
  },
  signOut() {
    return ApiService.post(`marking/auth/sign-out`)
  },
  checkConnection() {
    return ApiService.post(`marking/connection/check`)
  },
  getDashboard() {
    return ApiService.get(`marking/dashboard`)
  },
  getDiagnostics() {
    return ApiService.get(`marking/diagnostics`)
  },
  runDiagnostic(step, params) {
    return ApiService.post(`marking/diagnostics/${step}`, params)
  },
  identify(code) {
    return ApiService.post(`marking/identify`, { code })
  },
  linkMaterial(materialId, gtin) {
    return ApiService.post(`marking/material/${materialId}/link`, { gtin })
  },
  checkCodes(codes) {
    return ApiService.post(`marking/codes/check`, { codes })
  },
  fixCode(codeId, params) {
    return ApiService.post(`marking/codes/${codeId}/fix`, params)
  },
  codeHistory(codeId) {
    return ApiService.get(`marking/codes/${codeId}/history`)
  },
  getDocumentCodes(documentId) {
    return ApiService.get(`marking/warehouse/document/${documentId}`)
  },
  scanDocument(documentId, codes) {
    return ApiService.post(`marking/warehouse/document/${documentId}/scan`, { codes })
  },
  deleteDocumentCode(documentId, codeId) {
    return ApiService.post(`marking/warehouse/document/${documentId}/code/${codeId}/delete`)
  },
  getVisit(recordId) {
    return ApiService.get(`marking/visit/${recordId}`)
  },
  scanVisit(recordId, code) {
    return ApiService.post(`marking/visit/${recordId}/scan`, { code })
  },
  deleteVisitCode(recordId, codeId) {
    return ApiService.post(`marking/visit/${recordId}/code/${codeId}/delete`)
  },
  getPending() {
    return ApiService.get(`marking/pending`)
  },
  scanPending(codes, params = {}) {
    return ApiService.post(`marking/pending/scan`, { codes, ...params })
  },
  prepareExchange() {
    return ApiService.post(`marking/exchange/prepare`)
  },
  signExchange(documents) {
    return ApiService.post(`marking/exchange/sign`, { documents })
  },
  retryOperation(id) {
    return ApiService.post(`marking/operation/${id}/retry`)
  },
  cancelOperation(id, comment = null) {
    return ApiService.post(`marking/operation/${id}/cancel`, { comment })
  },
  retryDocument(id) {
    return ApiService.post(`marking/document/${id}/retry`)
  },
}
